import { put, takeEvery } from 'redux-saga/effects';
import { ENDPOINT } from '../../services/apiUrls';
import { getLenders, saveLenders, updateLenderError } from '../slices/lenders';
import createApiInstance from '../../services/api';
import { BASE_API_URL } from '../../config';

// Dynamically create the API instance with the base URL
const api = createApiInstance(BASE_API_URL); // Replace BASE_API_URL with the dynamic value you have

export interface ResponseGenerator {
  config?: any;
  data?: any;
  headers?: any;
  request?: any;
  status?: number;
  statusText?: string;
  code?: string;
}

function* getLendersData(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.LENDERS.getLendersApi,
      data: actions.payload.dataToPost,
    });

    if (response?.status) {
      yield put(saveLenders(response));
      actions.payload.callback(response);
    } else {
      yield put(saveLenders(null));
      actions.payload.callback(false);
    }
    yield put(updateLenderError({ errInFetchingLenders: false }));
  } catch (error) {
    yield put(saveLenders(null));
    actions.payload.callback(false);
    yield put(updateLenderError({ errInFetchingLenders: true }));
    console.log(error);
  }
}

export default function* root() {
  yield takeEvery(getLenders.type, getLendersData);
}
